// src/components/GrupoRaque.mjs
import React, { useEffect } from 'react';

const GTM_ID = 'GTM-5QHPSKP5';

const GrupoRaque = () => {
    const redirectUrl = process.env.REACT_APP_GRUPO_RAQUE_URL || '#';

    useEffect(() => {
        // 1. Dispara o Redirecionamento IMEDIATAMENTE
        window.location.href = redirectUrl;

        // 2. Carrega o GTM em paralelo (sem bloquear o redirecionamento)
        if (!window.dataLayer) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });

            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
            document.head.insertBefore(script, document.head.firstChild);
        }
    }, [redirectUrl]);

    // Retorna nulo ou uma tela em branco, já que o usuário não ficará aqui
    return null;
};

export default GrupoRaque;
